import Info from '@mdi/svg/svg/information.svg?react';
import { MDIIcon } from '@solinkcorp/solink-components';
import moment from 'moment';
import React, { useMemo } from 'react';
import useLocale from 'src/hooks/useLocale';
import TimeFormatter from 'utils/TimeFormatter';
import './TimezoneNotice.sass';

const TimezoneNotice: React.FC<{
  timezoneId: string;
  className?: string;
  colorMode?: string;
}> = (props) => {
  const locale = useLocale();
  const { timezoneId, className = '', colorMode = 'light' } = props;
  const nowMomentDevice = useMemo(() => moment().clone().tz(timezoneId), [timezoneId]);
  const dateFormatted = nowMomentDevice.format('LL');
  const timeFormatted = nowMomentDevice.format(TimeFormatter.getString({ zeroPrefix: false }));

  // `timezoneId` is optional in location; don't display this box if there's no timezone.
  if (!timezoneId) {
    return null;
  }

  return (
    <div className={`timezone-notice mode-${colorMode} ${className}`}>
      <MDIIcon icon={Info} size={18} className="icon-sprite" style={{ alignSelf: 'flex-start' }} />
      <div className="timezone-notice-text">
        <p>{locale.alarms.basedOnLocalTimeZone}</p>
        <p>
          {locale.alarms.localTime}{' '}
          <span>
            {dateFormatted} {timeFormatted}.
          </span>
        </p>
      </div>
    </div>
  );
};

export default TimezoneNotice;
